import NewSelectorMultiple from '@/pages/dashboard/components/NewSelectorMultiple';
import { DownloadButton } from "@/pages/dashboard/components/Plugin/DownloadButton";
import { SearchBox } from "@/pages/dashboard/components/Plugin/SearchBox";

export default {
  DownloadButton,
  NewSelectorMultiple,
  SearchBox,
};